import ClassConstants from './class';
import SilverDecisionsConstants from './silver-decisions';

export const toggleList = ['UNDO', 'REDO'];

export const eventClassList = [
    {
        from: ClassConstants.NEW_PROJECT_CLASS,
        to: SilverDecisionsConstants.NEW_PROJECT_CLASS,
    },
    {
        from: ClassConstants.TEMPLATE_PROJECT_CLASS,
        to: SilverDecisionsConstants.TEMPLATE_PROJECT_CLASS,
    },
    {
        from: ClassConstants.OPEN_PROJECT_CLASS,
        to: SilverDecisionsConstants.OPEN_PROJECT_CLASS,
    },
    {
        from: ClassConstants.SAVE_PROJECT_CLASS,
        to: SilverDecisionsConstants.SAVE_PROJECT_CLASS,
    },
    {
        from: ClassConstants.PROJECT_SETTINGS_CLASS,
        to: SilverDecisionsConstants.PROJECT_SETTINGS_CLASS,
    },
    {
        from: ClassConstants.LAYOUT_MANUAL,
        to: SilverDecisionsConstants.LAYOUT_MANUAL,
    },
    {
        from: ClassConstants.LAYOUT_TREE,
        to: SilverDecisionsConstants.LAYOUT_TREE,
    },
    {
        from: ClassConstants.LAYOUT_CLUSTER,
        to: SilverDecisionsConstants.LAYOUT_CLUSTER,
    },
    {
        from: ClassConstants.EXPORT_TO_PNG,
        to: SilverDecisionsConstants.EXPORT_TO_PNG,
    },
    {
        from: ClassConstants.EXPORT_TO_SVG,
        to: SilverDecisionsConstants.EXPORT_TO_SVG,
    },
    {
        from: ClassConstants.EXPORT_TO_PDF,
        to: SilverDecisionsConstants.EXPORT_TO_PDF,
    },
    {
        from: ClassConstants.UNDO,
        to: SilverDecisionsConstants.UNDO,
    },
    {
        from: ClassConstants.REDO,
        to: SilverDecisionsConstants.REDO,
    },
    {
        from: ClassConstants.HELP,
        to: SilverDecisionsConstants.HELP,
    },
    // {
    //     from: ClassConstants.HORIZONTAL_MARGIN,
    //     to: SilverDecisionsConstants.HORIZONTAL_MARGIN,
    // },
    // {
    //     from: ClassConstants.VERTICAL_MARGIN,
    //     to: SilverDecisionsConstants.VERTICAL_MARGIN,
    // },
    {
        from: ClassConstants.MAX_EDGE,
        to: SilverDecisionsConstants.MAX_EDGE,
    },
    {
        from: ClassConstants.WIDTH_SIZE,
        to: SilverDecisionsConstants.WIDTH_SIZE,
    },
    {
        from: ClassConstants.HEIGHT_SIZE,
        to: SilverDecisionsConstants.HEIGHT_SIZE,
    },
    {
        from: ClassConstants.VARIABLES,
        to: SilverDecisionsConstants.VARIABLES,
    },
    {
        from: ClassConstants.SENSITIVITY,
        to: SilverDecisionsConstants.SENSITIVITY,
    },
    {
        from: ClassConstants.RECALCULATE,
        to: SilverDecisionsConstants.RECALCULATE,
    },
];



// WEBPACK FOOTER //
// ./scripts/components/constants/eventClassList.js